import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-terms-of-use',
  imports: [],
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.scss'
})
export class TermsOfUseComponent {
  constructor(private readonly router: Router) {}

  onNavigateToPrivacy() {
    this.router.navigate(['/privacy-statement']);
  }

  navigateHome() {
    this.router.navigate(['/']);
  }

}
